import { Component, Inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-data-view',
  imports: [CommonModule],
  templateUrl: './pickerltyp.list-view.html',
  styleUrls: ['./pickerltyp.list-view.scss'],
})
export class PickerltypListView implements FieldOkItemComponent<any> {
  @Input() item: any;

  constructor() {}
}
